import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import {useReactiveVar} from "@apollo/client";


import { config } from "../../config";
import { LinksArray } from './Links'
import MobileNavigation from './MobileNavigation'
import { links } from '../../Router'
import {isApiVar} from '../../cache'


const Navigation = (props) => {
  const [open, toggleOpen] = useState(true);
  const isApi = useReactiveVar(isApiVar);


  useEffect(() => {
    toggleOpen(true)
  }, [])


  return(
    <Wrapper isApi={isApi} open={open}>
      <Dots>
        <Dot color="#DC3C3A" />
        <Dot color="#000000" />
        <Dot color="#1F4AAD" />
        <Dot color="#F7DA49" />
      </Dots>
      <Link to={"/"}>
        <Logo width={124} alt={config.logo} src={config.logo} />
      </Link>
      <LinkWrapper>
        <LinksArray links={links} />
      </LinkWrapper>
      <MobileNavigation />
    </Wrapper>
  )
}

export default Navigation


const Logo = styled.img(props => ({
  width:props.width,
  cursor:"pointer",
  marginLeft:48,
  "@media (max-width: 650px)": {
    marginLeft:0,
  }
}));

const Dots = styled.div(props => ({
  "@media (max-width: 650px)": {
    display:"none",
  }
}));

const Dot = styled.div(props => ({
  background: props.color,
  width:4,
  height:10,
}));

const LinkWrapper = styled.div(props => ({
  display:"flex",
  alignItems:"center",
  justifyContent:"flex-end",
  flexGrow:10,
  marginRight:76,
  "@media (max-width: 650px)": {
    display:"none",
  }
}));

const Wrapper = styled.div(props => ({
  zIndex:1,
  top: props.open ? 0 : -108,
  transition:"0.6s ease-in-out",
  position: "absolute",
  width: props.open ? "100%" : 0,
  display: props.isApi ? "none" : "flex",
  justifyContent:"space-between",
  alignItems:"center",
  height: 108,
  "@media (max-width: 650px)": {
    paddingLeft:16,
    paddingRight:16,
    width:"calc(100% - 32px)",
    top: props.open ? 0 : -72,
    height: 72,
  }
}));
